import { useDeepCompareMemo } from "@react-hookz/web";
import type { FunctionComponent } from "react";

import type {
  ContentSchemaRenderProps,
  RenderComponent,
  RenderMap,
} from "~/components/content/content-schema-render/index";

import { InlineAdSlotSchemaType, isInlineAdSlotSchema } from "./schemas";
import { StyledInlineAdSlot } from "./styles";

import { type Props as InlineAdSlotProps } from ".";

export type InlineAdSlotRenderProps = Partial<Record<string, InlineAdSlotProps>>;

export const useInlineAdSlotRender = (inlineAdSlots: InlineAdSlotRenderProps) => {
  const inlineAdSlotRenders: RenderMap<
    RenderComponent<ContentSchemaRenderProps, FunctionComponent<ContentSchemaRenderProps>>
  > = useDeepCompareMemo(
    () => ({
      [InlineAdSlotSchemaType]: ({ schemaNode }: ContentSchemaRenderProps) => {
        const isInlineAdSlotNode = isInlineAdSlotSchema(schemaNode);
        if (!isInlineAdSlotNode) return null;

        const matchedAdSlot = inlineAdSlots[schemaNode.attribs?.tag];
        if (!matchedAdSlot) return null;

        return <StyledInlineAdSlot {...matchedAdSlot} />;
      },
    }),
    [inlineAdSlots],
  );

  return { inlineAdSlotRenders };
};
